import { Injectable } from '@angular/core'
import * as FileSaver from 'file-saver'

@Injectable({
  providedIn: 'root',
})
export class DataTableService {
  exportPdf(columns: any[], data: any) {
    return import('jspdf').then((jsPDF) => {
      //! jspdf-autotable 5 ya no extiende el prototype de jsPDF, asi que `doc.autoTable` no existe, y
      //! tampoco conserva la firma POSICIONAL `autoTable(columnas, filas)` que habia aqui — era de la
      //! version 2. El equivalente exacto es la forma de funcion con `columns` + `body`: las filas
      //! siguen siendo objetos indexados por `dataKey`, y lo unico que cambia es que la etiqueta de
      //! la columna se llama `header` y no `title`. El llamador (`main-table`) no se toca.
      return import('jspdf-autotable').then(({ default: autoTable }) => {
        let large = Object.keys(columns).length * 120
        large = large <= 1000 ? 1000 : large
        const doc = new jsPDF.default('l', 'px', [1000, large])
        autoTable(doc, {
          columns: columns.map((c) => ({ header: c.title, dataKey: c.dataKey })),
          body: data,
        })
        doc.save('products.pdf')
      })
    })
  }

  exportExcel(data: any, customFileName?: string) {
    import('xlsx')
      .then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(data)
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
        const fileName = customFileName || 'products'
        this.saveAsExcelFile(excelBuffer, fileName)
      })
      .catch((e) => {
        console.log(e.message)
      })
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    let EXCEL_EXTENSION = '.xlsx'
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    })
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
  }
}
